import Button from './Button'
import {
  ButtonProps,
  buttonStyleArray,
  buttonSizeArray,
  buttonTypeArray,
} from './Button'

export default Button

export {ButtonProps, buttonStyleArray, buttonSizeArray, buttonTypeArray}
